import { Api } from "../../core/services/api.services";
import LayoutMain from "../../shared/layouts/LayoutMain/LayoutMain";
import { BCFormList } from "../../shared/styled/global.styled";
import { useService } from "../../hook/useServices";
import { Fields } from "../../shared/interface/fields";


const getFields = async () => {
  const { data } = await Api.getFields();
  return data;
};

const FieldsPage = () => {
  const serviceQuery = useService('fields', getFields);
  const fields: Fields[] = serviceQuery.data as unknown as Fields[];
  
  return (
    <LayoutMain idPage="Campos" titlePage={true}>

      {serviceQuery.isLoading && <div className="bc-preloader bc-preloader-line"></div>}
      {fields &&
        fields.map((fields: Fields) => (
          <BCFormList className="bc-card" key={fields.id}>
            <h6>Id: </h6>
            <p>{fields.id}</p>
            <h6>Nombre: </h6>
            <p>{fields.name}</p>
            <h6>Código: </h6>
            <p>{fields.code}</p>
          </BCFormList>
        ))}
    </LayoutMain>
  );
};

export default FieldsPage;
